import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";

export const EMPTY_FORMATION = { salaries_formes: 0, heures_formation: 0, budget_formation: 0, apprentis_stagiaires: 0 };
export const EMPTY_DIALOGUE = {
  delegues_personnel: 0, syndicats_presents: false, convention_collective: false,
  reunions_representants: 0, accords_signes: 0, conflits_collectifs: 0,
};

const CATEGORIES = [
  ["cadres", "Cadres"], ["agents_maitrise", "Agents de maîtrise"], ["employes", "Employés"], ["ouvriers", "Ouvriers"],
];

const NumField = ({ section, field, label, data, onChange, step }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <Input
      type="number" min="0" step={step || "1"}
      value={data?.[field] || ""}
      placeholder="0"
      onChange={(e) => onChange(section, field, e.target.value)}
      data-testid={`${section.replace(/_/g, "-")}-${field.replace(/_/g, "-")}-input`}
    />
  </div>
);

export const CategorySexFields = ({ emploi, onChange }) => (
  <div data-testid="category-sex-fields">
    <h3 className="font-semibold mb-1">Répartition par sexe et par catégorie</h3>
    <p className="text-xs text-muted-foreground mb-3">Permet la carte de chaleur catégorie × sexe du rapport. Le total de chaque ligne doit égaler l'effectif de la catégorie.</p>
    <div className="space-y-2">
      {CATEGORIES.map(([key, label]) => {
        const sum = (emploi[`${key}_hommes`] || 0) + (emploi[`${key}_femmes`] || 0);
        const mismatch = sum > 0 && sum !== (emploi[key] || 0);
        return (
          <div key={key} className="grid grid-cols-[1fr_1fr_1fr] md:grid-cols-[180px_1fr_1fr_160px] gap-3 items-end">
            <span className="text-sm font-medium col-span-3 md:col-span-1">{label}</span>
            <NumField section="emploi" field={`${key}_hommes`} label="Hommes" data={emploi} onChange={onChange} />
            <NumField section="emploi" field={`${key}_femmes`} label="Femmes" data={emploi} onChange={onChange} />
            <span className={`text-xs ${mismatch ? "text-red-600 font-semibold" : "text-muted-foreground"}`} data-testid={`category-sex-check-${key}`}>
              {sum} / {emploi[key] || 0}{mismatch ? " ≠ effectif" : ""}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);

export const FormationDialogueFields = ({ formData, onChange }) => (
  <div className="space-y-6">
    <div>
      <h3 className="font-semibold mb-4">Formation professionnelle</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <NumField section="formation" field="salaries_formes" label="Salariés formés" data={formData.formation} onChange={onChange} />
        <NumField section="formation" field="heures_formation" label="Heures de formation" data={formData.formation} onChange={onChange} />
        <NumField section="formation" field="budget_formation" label="Budget formation (GNF)" data={formData.formation} onChange={onChange} />
        <NumField section="formation" field="apprentis_stagiaires" label="Apprentis / stagiaires" data={formData.formation} onChange={onChange} />
      </div>
    </div>
    <div>
      <h3 className="font-semibold mb-4">Dialogue social</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <NumField section="dialogue_social" field="delegues_personnel" label="Délégués du personnel" data={formData.dialogue_social} onChange={onChange} />
        <NumField section="dialogue_social" field="reunions_representants" label="Réunions avec les représentants" data={formData.dialogue_social} onChange={onChange} />
        <NumField section="dialogue_social" field="accords_signes" label="Accords signés" data={formData.dialogue_social} onChange={onChange} />
        <NumField section="dialogue_social" field="conflits_collectifs" label="Conflits collectifs" data={formData.dialogue_social} onChange={onChange} />
      </div>
      <div className="flex flex-wrap gap-6 mt-4">
        {[["syndicats_presents", "Présence syndicale"], ["convention_collective", "Convention collective appliquée"]].map(([field, label]) => (
          <label key={field} className="flex items-center gap-2 text-sm">
            <Switch
              checked={!!formData.dialogue_social?.[field]}
              onCheckedChange={(v) => onChange("dialogue_social", field, v)}
              data-testid={`dialogue-social-${field.replace(/_/g, "-")}-switch`}
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  </div>
);

export const EtpField = ({ effectifs, onChange }) => (
  <div className="max-w-xs">
    <NumField section="effectifs" field="effectif_etp" label="Effectif en équivalent temps plein (ETP)" data={effectifs} onChange={onChange} step="0.1" />
  </div>
);
